// ===== IMAGES IMPORTS =====
import royal_jewel_cover from "../images/projects/royal_jewel_cover.png";
import doha_heights_cover from "../images/projects/doha_heights.png";
import floria_heights_cover from "../images/projects/floria_heights_cover.jpg";
import deen_villas_cover from "../images/projects/deen_villas_cover.png";
import urban_complex_cover from "../images/projects/urban_complex_cover.png";
import b7_tower_cover from "../images/projects/b7_tower_cover.png";
import valencia_heights_cover from "../images/projects/valencia-heights-cover.jpeg";
import j7_emporium_cover from "../images/projects/j7-emporium-cover.jpeg";
import rs_mall_cover from "../images/projects/rs_mall_cover.png";
import islamabad_heights_cover from "../images/projects/islamabad_heights_cover.png";
import burj_quaid_cover from "../images/projects/burj_quaid_cover.png";
import tower4_cover from "../images/projects/tower4_cover.png";
import sukoon_vista_cover from "../images/projects/sukoon_vista_cover.png";
// HMR Waterfront import
import hmr_waterfront_cover from "../images/projects/HMR Waterfront/hmr_waterfront_cover.png";
// 🔍 NEW: Citadel 7 cover — add the image to /src/images/projects/citadel7-cover.png
import citadel7_cover from "../images/projects/citadel7_cover.png";

// ===== COMPANIES DATA =====
export const companiesData = [
  // 🔍 NEW: Chakor Ventures (Citadel 7) — placed first to match project order
  {
    id: 12,
    name: "Chakor Ventures",
    logo: "🏙️",
    projectsCount: 1,
    description:
      "Chakor Ventures is an emerging high-rise real estate developer that is changing the urban landscape of Pakistan. The company aims to create world-class commercial and residential spaces using its extensive expertise, cutting-edge technology, and quality resources. Its vision is to develop state-of-the-art industry-leading projects while empowering communities and promoting economic growth — starting with Citadel 7, Pakistan's first smart tech tower in Main Blue Area, Islamabad.",
  },
  // ABS Developers
  {
    id: 9,
    name: "ABS Developers",
    logo: "🏗️",
    projectsCount: 1,
    description:
      "At ABS Developers, we began with a clear commitment: to build the right way. A pioneer in shariah-compliant real estate, our foundation rests on transparency, security, and trust. From high-rises to commercial hubs, we have consistently delivered projects that combine quality materials, strict timelines, and practical luxury. Our developments include some of the tallest towers across major cities, because we believe Pakistan's urban centers deserve landmarks that reflect ambition and long-term value.",
  },
  // Hussain Marketing and Developers
  {
    id: 10,
    name: "Hussain Marketing and Developers",
    logo: "🏢",
    projectsCount: 2,
    description:
      "Hussain Marketing and Developers is a premier real estate development company dedicated to creating exceptional living and commercial spaces. With a commitment to quality, innovation, and customer satisfaction, we deliver projects that set new standards in modern living. Our developments combine strategic locations, premium amenities, and thoughtful design to create communities where families can thrive and businesses can succeed.",
  },
  // J7 Group
  {
    id: 7,
    name: "J7 Group",
    logo: "🏙️",
    projectsCount: 1,
    description:
      "Leading real estate developer known for delivering iconic high-rise projects in record time. J7 Group combines visionary leadership with enriched brilliance, resources, and experience to create landmark developments in Islamabad.",
  },
  // Red Sun Associates
  {
    id: 8,
    name: "Red Sun Associates",
    logo: "🏢",
    projectsCount: 1,
    description:
      "A legacy of excellence and commitment in the real estate industry for over 3 decades. Red Sun Associates has crafted iconic landmarks and transformed cityscapes with unwavering commitment to quality, innovation, and customer satisfaction. With more than 10 million square feet of covered area delivered across twin cities, the company has established itself as a pioneer in the builders industry.",
  },
  {
    id: 1,
    name: "Seven Ventures",
    logo: "🌆",
    projectsCount: 1,
    description:
      "Luxury residential and lifestyle developments focused on elevated modern living",
  },
  {
    id: 2,
    name: "Deen Associates",
    logo: "🏡",
    projectsCount: 2,
    description:
      "Premium villa and mixed-use developments focused on luxury living, comfort, and long-term investment value.",
  },
  {
    id: 3,
    name: "Marjan Associates and Builders",
    logo: "🏢",
    projectsCount: 1,
    description:
      "Commercial and residential high-rise specialists delivering premium mixed-use and office towers.",
  },
  {
    id: 4,
    name: "Abbasi Builders & Property Consultants",
    logo: "🏛️",
    projectsCount: 1,
    description: "Commercial and residential high-rise specialists",
  },
  {
    id: 5,
    name: "B7 Marketing and Developers",
    logo: "🏬",
    projectsCount: 2,
    description:
      "Premier marketing and development firm dedicated to elevating business environments through premium commercial projects and strategic investment opportunities.",
  },
  {
    id: 6,
    name: "Valencia Developers",
    logo: "🏗️",
    projectsCount: 1,
    description:
      "Premium residential developers focused on creating family-friendly communities with modern amenities and prime locations.",
  },
  // HMR Group
  {
    id: 11,
    name: "HMR Group",
    logo: "🌊",
    projectsCount: 1,
    description:
      "HMR Group is a real estate development giant in Pakistan and an acclaimed name in the UAE. Founded in 2015 by Dr. Haji Muhammad Rafiq Pardesi, the group is known for crafting extraordinary luxury with internationally recognized high-rise and medium-rise residential and commercial towers. With a focus on diversification and innovation, HMR Group has become the brand of choice in delivering quality, novelty, and service across Pakistan, UAE, and Africa.",
  },
];

// ===== PROJECTS DATA =====
export const projectsData = [
  // 🔍 NEW: Citadel 7 — Chakor Ventures
  {
    id: 15,
    companyId: 12,
    title: "Citadel 7",
    route: "citadel7",
    image: citadel7_cover,
    location: "Main Blue Area, Jinnah Avenue, Islamabad",
    city: "Islamabad",
    type: "Smart Tech Commercial Tower",
    status: "Launching",
    duration: "60% Booking + 2 Monthly Installments + 10% on Possession",
    description:
      "Citadel 7 is Pakistan's first smart tech tower, a future-ready corporate landmark in Main Blue Area, Islamabad, developed by Chakor Ventures. Located directly opposite Centaurus Mall and PIMS Hospital with direct entrances from Jinnah Avenue and Ibn-e-Sina Road, Citadel 7 combines AI-powered infrastructure with premium office spaces across 20+ floors. The tower features an AI-enabled Building Management System (BMS), FTTO fiber-optic connectivity from multiple ISPs, Starlink-ready infrastructure, zero-power-downtime UPS and generators, smart VRF and HVAC systems with office-wise control, D.C.S. AI-optimized elevator routing, NFPA-compliant fire fighting systems, 4-level basement parking with EV charging, high-performance UV-controlled facade, and 70-person capacity elevators. Designed for entrepreneurs, innovators, and global enterprises, Citadel 7 is where vision meets value.",
    features: [
      "Pakistan's First Smart Tech Tower",
      "Prime Location: Main Blue Area, Jinnah Avenue, Islamabad",
      "Directly Opposite Centaurus Mall",
      "Directly Opposite PIMS Hospital",
      "Direct Entrances from Jinnah Avenue & Ibn-e-Sina Road",
      "AI-Powered Building Management System (BMS)",
      "Zero Power Downtime (Generators + UPS)",
      "Zero Dead Spot (Advanced W-LAN / FTTO)",
      "FTTO Fiber-Optic from Multiple ISPs",
      "Starlink-Ready Infrastructure",
      "Smart VRF & HVAC with Office-Wise Control",
      "GPON Announcement System",
      "PBAX Intercom Connectivity",
      "High-Performance UV-Controlled Facade",
      "Noise Reduction & Energy Saving",
      "NFPA-Compliant Fire Fighting System",
      "UL-Listed Fire Equipment",
      "Fire-Fighting Equipped Elevators",
      "Fire-Rated Doors & Smoke Sensors",
      "70-Person Capacity Elevators",
      "D.C.S. AI-Enabled Optimized Routing",
      "4-Level Basement Parking (200+ Vehicles)",
      "EV Charging Stations",
      "Advanced Cybersecurity Infrastructure",
      "Tech-Secure Business Environment",
      "1 Minute to Expressway",
      "1 Minute to 9th Avenue",
      "2 Minutes to 7th Avenue",
      "3 Minutes to Margalla Road",
      "3 Minutes to Srinagar Highway",
      "Metro Access: Red, Green, Blue & Orange Lines",
      "5 Minutes to Faisal Mosque",
      "5 Minutes to National Assembly",
      "5 Minutes to Supreme Court",
      "5 Minutes to Marriott Hotel",
      "27 Minutes to Islamabad Airport",
    ],
    gallery: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600",
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=600",
      "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600",
      "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=600",
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600",
    ],
  },
  // Burj Quaid — ABS Developers
  {
    id: 11,
    companyId: 9,
    title: "Burj Quaid",
    route: "burj-quaid",
    image: burj_quaid_cover,
    location: "DHA City, Karachi",
    city: "Karachi",
    type: "Mixed-Use Commercial & Residential High-Rise",
    status: "Launching",
    duration:
      "25% Down Payment + 23 Quarterly Installments + Last Payment",
    description:
      "Burj Quaid is Pakistan's tallest tower, a modern symbol of elevated living and premium retail that embodies national pride while reflecting Quaid-e-Azam's vision of a progressive, disciplined, and self-reliant Pakistan. With an approved height of 941 Feet (286.8m), it features the highest mosque, highest observation deck, highest occupied floor, and highest service elevator in Pakistan. This iconic development combines architectural brilliance with exceptional residences, spectacular views, and exquisite living spaces. A landmark where prestige is not only admired, but experienced every day.",
    features: [
      "Tallest Tower of Pakistan (941 Feet / 286.8m)",
      "Highest Mosque of Pakistan",
      "Highest Observation Deck in Pakistan",
      "Highest Occupied Floor in Pakistan",
      "Highest Service Elevator in Pakistan",
      "100+ World-Class Amenities",
      "Sky Walk with Breathtaking Panoramic Views",
      "5-Star Hotel with Global Hospitality Standards",
      "Pakistan's 1st Advanced Integrated Business Hub",
      "AI-Powered Smart Infrastructure",
      "Enterprise-Grade Connectivity",
      "Infinity Pool with Spectacular Views",
      "Grand Auditorium for Events & Conferences",
      "State-of-the-Art Gymnasium",
      "Jogging Tracks & Badminton Courts",
      "Indoor Water Park & Indoor Swimming Pools",
      "Fine Dining & Courtyard Restaurant",
      "Beautifully Designed Sky Gardens",
      "Sky-High Lounge & Cafe",
      "Luxury Residences: 1, 2, 3 & 4 Bed Apartments",
      "Premium Penthouses with Panoramic Views",
      "Smart Parking System",
      "24/7 CCTV Security",
      "Earthquake Resistant Structure",
      "High-Speed Elevators",
      "Shariah-Compliant Investment",
      "Prime Location in DHA City Karachi",
      "Close to Fairwinds Golf Course",
      "Near DHA Suffa University",
      "Adjacent to Shaukat Khanum Hospital",
    ],
    gallery: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600",
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=600",
      "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600",
      "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=600",
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600",
    ],
    paymentPlan: [
      { type: "Residential 1-Bed (660 sqft)", rate: "26,999", downPayment: "2,700,000", quarterly: "625,000", last: "744,340", total: "17,819,340" },
      { type: "Residential 1-Bed (1090 sqft)", rate: "26,999", downPayment: "4,400,000", quarterly: "1,025,000", last: "1,453,910", total: "29,428,910" },
      { type: "Residential 2-Bed (1480 sqft)", rate: "26,999", downPayment: "6,000,000", quarterly: "1,400,000", last: "1,758,520", total: "39,958,520" },
      { type: "Residential 2-Bed (2185 sqft)", rate: "26,999", downPayment: "8,800,000", quarterly: "2,075,000", last: "2,467,815", total: "58,992,815" },
      { type: "Residential 3-Bed (2185 sqft)", rate: "26,999", downPayment: "8,800,000", quarterly: "2,075,000", last: "2,467,815", total: "58,992,815" },
      { type: "Residential 3-Bed (3055 sqft)", rate: "26,999", downPayment: "12,400,000", quarterly: "2,875,000", last: "3,956,945", total: "82,481,945" },
      { type: "Residential 3-Bed (4130 sqft)", rate: "26,999", downPayment: "16,700,000", quarterly: "3,900,000", last: "5,105,870", total: "111,505,870" },
      { type: "Residential 4-Bed (5315 sqft)", rate: "26,999", downPayment: "21,500,000", quarterly: "5,025,000", last: "6,424,685", total: "143,499,685" },
      { type: "Commercial Office (400 sqft)", rate: "55,000", downPayment: "3,300,000", quarterly: "7,750,000", last: "875,000", total: "22,000,000" },
      { type: "Commercial Office (600 sqft)", rate: "55,000", downPayment: "5,000,000", quarterly: "1,150,000", last: "1,550,000", total: "33,000,000" },
      { type: "Commercial Office (1000 sqft)", rate: "55,000", downPayment: "8,300,000", quarterly: "1,925,000", last: "2,425,000", total: "55,000,000" },
    ],
    floorPlans: {
      residential: [
        { name: "1 BED SIGNATURE Apartment", netArea: "527 Sqft", grossArea: "660 Sqft" },
        { name: "1 BED ROYAL Apartment", netArea: "871 Sqft", grossArea: "1090 Sqft" },
        { name: "2 BED SIGNATURE Apartment", netArea: "1183 Sqft", grossArea: "1480 Sqft" },
        { name: "2 BED ROYAL Apartment", netArea: "1747 Sqft", grossArea: "2185 Sqft" },
        { name: "3 BED SIGNATURE Apartment", netArea: "1747 Sqft", grossArea: "2185 Sqft" },
      ],
      commercial: [
        { name: "Commercial Office", area: "400 Sqft" },
        { name: "Commercial Office", area: "600 Sqft" },
        { name: "Commercial Office", area: "1000 Sqft" },
      ],
      categories: [
        "General",
        "Corner",
        "Facing boulevard",
        "West open",
        "Corner + west open",
        "Facing boulevard + corner",
        "Facing boulevard + corner + west open",
      ],
      inclusions: [
        "Entrance Door with Lock",
        "Bedroom Wardrobes",
        "Internal Doors & Hardware",
        "Kitchen Cabinets",
        "Floor Tiles",
        "Kitchen Countertop",
        "Wall Paint",
        "Kitchen Hood, Hob & Sink",
        "False Ceiling (where applicable)",
        "Kitchen Exhaust",
        "Lighting Fixtures",
        "Washrooms with Sanitary Fittings",
        "Electrical Switches & Power Sockets",
        "Washroom Vanity with Mirror",
        "Windows",
        "Balcony Glass Railing",
      ],
    },
  },
  // Tower4 — Hussain Marketing and Developers
  {
    id: 12,
    companyId: 10,
    title: "Tower4",
    route: "tower4",
    image: tower4_cover,
    location: "Sector B-17, Islamabad",
    city: "Islamabad",
    type: "Luxury Residential High-Rise",
    status: "Pre-Launching",
    duration: "Flexible Installment Plan",
    description:
      "Tower4 is a prestigious residential high-rise development in Sector B-17, Islamabad, brought to you by Hussain Marketing and Developers. This architectural masterpiece offers a perfect blend of modern design, premium amenities, and strategic location. Tower4 features luxurious apartments with breathtaking views, state-of-the-art facilities, and a lifestyle that redefines urban living. Every detail has been meticulously crafted to provide residents with the ultimate living experience.",
    features: [
      "Luxury Residential High-Rise",
      "Prime Location in Sector B-17",
      "Breathtaking Panoramic Views",
      "Modern Architectural Design",
      "Premium Quality Construction",
      "State-of-the-Art Amenities",
      "24/7 CCTV Security",
      "Earthquake Resistant Structure",
      "High-Speed Elevators",
      "Smart Parking System",
      "Easy Access to Motorway M1/M2",
      "Close to New Islamabad Airport",
      "Near CPEC Route",
      "Family-Friendly Environment",
      "Professional Property Management",
    ],
    gallery: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600",
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=600",
      "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600",
      "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=600",
    ],
  },
  // Sukoon Vista — Hussain Marketing and Developers
  {
    id: 13,
    companyId: 10,
    title: "Sukoon Vista",
    route: "sukoon-vista",
    image: sukoon_vista_cover,
    location: "Sector B-17, Islamabad",
    city: "Islamabad",
    type: "Luxury Residential & Commercial Project",
    status: "Pre-Launching",
    duration: "Flexible Installment Plan",
    description:
      "Sukoon Vista is a premium residential and commercial development in Sector B-17, Islamabad, by Hussain Marketing and Developers. Designed to provide 'Sukoon' (peace) and 'Vista' (views), this project offers the perfect combination of tranquility and modern living. With strategically designed spaces, world-class amenities, and a prime location, Sukoon Vista promises an elevated lifestyle for families and professionals alike.",
    features: [
      "Luxury Residential & Commercial Project",
      "Strategic Location in Sector B-17",
      "Peaceful & Serene Environment",
      "Modern Architectural Design",
      "Premium Quality Construction",
      "State-of-the-Art Amenities",
      "24/7 CCTV Security",
      "Earthquake Resistant Structure",
      "High-Speed Elevators",
      "Smart Parking System",
      "Commercial Spaces Available",
      "Easy Access to Motorway M1/M2",
      "Close to New Islamabad Airport",
      "Near CPEC Route",
      "Family-Friendly Community",
      "Professional Property Management",
      "Investment Opportunity",
    ],
    gallery: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600",
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=600",
      "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600",
      "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=600",
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600",
    ],
  },
  // HMR Waterfront — HMR Group
  {
    id: 14,
    companyId: 11,
    title: "HMR Waterfront",
    route: "hmr-waterfront",
    image: hmr_waterfront_cover,
    location: "Abdul Sattar Edhi Avenue, D.H.A. Phase 8 Ext., Karachi",
    city: "Karachi",
    type: "Luxury Sea-Facing Residential & Commercial High-Rise",
    status: "Launching",
    duration: "Flexible Installment Plan",
    description:
      "HMR Waterfront is Karachi's ultimate lifestyle destination, a luxurious gated community located at the edge of the Great Arabian Sea in DHA Phase 8. Comprising fourteen high-rise residential towers, this iconic development by HMR Group offers luxury sea-facing apartments, townhouses, and penthouses with world-class amenities. Surrounded by green open spaces, a grand mosque, a marine walk promenade, and retail outlets, HMR Waterfront redefines premium coastal living. The project includes a revolutionary business district with top-notch business centers, offices, retail spaces, restaurants, and coffee shops. Additional facilities include high-speed elevators, abundant basement parking, a dedicated grid station with backup generators, a private filtration plant, a beautiful seafront promenade, and a beach clubhouse overlooking the glistening Arabian Sea. Approved by DHA, Karachi, HMR Waterfront is a marvel that encompasses all necessities of family living.",
    features: [
      "14 High-Rise Residential Towers",
      "Luxury Sea-Facing Apartments & Penthouses",
      "Townhouses Available",
      "Infinity Pools",
      "Fully Equipped Gyms",
      "24/7 Concierge Service",
      "24/7 CCTV Surveillance",
      "24/7 Power Backup",
      "High-Speed Elevators",
      "Fire Life Safety Certified Lifts",
      "Evacuation System",
      "Multiple Floors of Covered Parking",
      "Grand Mosque",
      "Seafront Promenade",
      "Beach Clubhouse",
      "Shopping Galleria & Retail Outlets",
      "Revolutionary Business District",
      "Dedicated Grid Station with Backup Generators",
      "Private Filtration Plant",
      "Green Open Spaces",
      "Modern Amenities & Efficient Security",
      "Approved by DHA, Karachi",
      "Prime Location on Abdul Sattar Edhi Avenue",
      "Close to Clock Tower (4.0 km)",
      "Close to Do Darya Restaurant (3.0 km)",
      "Close to Bay View Academy (5.0 km)",
      "Close to DHA Golf Club (5.2 km)",
      "Close to Ramada Hotel (7.3 km)",
      "Close to Dolmen Mall Clifton (7.9 km)",
    ],
    gallery: [
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600",
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600",
      "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=600",
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600",
      "https://images.unsplash.com/photo-1504384767178-ac8f0192fcea?w=600",
    ],
  },
  // J7 Emporium
  {
    id: 8,
    companyId: 7,
    title: "J7 Emporium",
    route: "j7-emporium",
    image: j7_emporium_cover,
    location: "Sector B-17, Islamabad",
    city: "Islamabad",
    type: "Mixed-Use Commercial & Residential High-Rise",
    status: "Pre-Launching",
    duration: "25% Down Payment + 8 Quarterly Installments",
    description:
      "J7 Emporium is a breathtaking 30-storey marvel nestled in the heart of Islamabad's Sector B-17, spanning an expansive 46 kanal. This iconic project is a testament to J7 Group's unwavering dedication to excellence, innovation, and luxury. Featuring a fusion of contemporary and modern architecture, J7 Emporium offers luxury apartments, a mega mall, smart parking, and Pakistan's first-ever Skywalk experience. The project includes residential towers with studio, 1, 2, and 3-bed apartments, a technology zone, corporate offices, food court, and a Radisson Hotel.",
    features: [
      "30-Storey High-Rise Building",
      "46 Kanal Expansive Project",
      "Luxury Apartments (Studio, 1, 2, 3 Bed)",
      "Mega Shopping Mall",
      "Pakistan's First Skywalk Experience",
      "Radisson Hotel",
      "Food Court with International Brands",
      "Corporate Tech Tower",
      "Infinity Pools with Breathtaking Views",
      "World-Class Gym & Fitness Facilities",
      "Serene Zen Gardens",
      "Rooftop Restaurants",
      "Smart Parking System",
      "Cinema & Entertainment Zone",
      "Fun City for Children",
      "J7 Club with Banquet Hall",
      "Swimming Pool & Spa",
      "24/7 CCTV Security",
      "Earthquake Resistant Structure",
      "High-Speed Elevators",
      "5 Mins Drive to Motorway M1/M2",
      "5 Mins Drive to CPEC Route",
      "15 Mins Drive to New Islamabad Airport",
      "Located on Iran Avenue (Margalla Avenue)",
    ],
    gallery: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600",
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=600",
      "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600",
      "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=600",
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600",
    ],
  },
  // RS Mall & Apartments
  {
    id: 9,
    companyId: 8,
    title: "RS Mall & Apartments",
    route: "rs-mall",
    image: rs_mall_cover,
    location: "Sector G-13/4, Islamabad",
    city: "Islamabad",
    type: "Mixed-Use Commercial & Residential High-Rise",
    status: "Launching Soon",
    duration: "25% Down Payment + 12 Quarterly Installments",
    description:
      "RS Mall & Apartments is a stunning mixed-use high-rise landmark in the heart of Islamabad's vibrant downtown Sector G-13/4. Spanning across a prime location, this iconic project marks a significant milestone in the evolution of the city, blending natural beauty with modern living. For almost 3 decades, Red Sun Associates has been proud to play a part in shaping the urban landscape, with a legacy of iconic developments that have transformed the way we live, work, and thrive.\n\nThis masterpiece, carefully crafted with the vision of Honorable Chairman Mr. Shahid Chan Zeb and the excellence of esteemed architects, features 3 floors of car parking, a dedicated mall area with Lower Ground, Ground plus 2 stories of well-designed commercial shops for renowned brands, a complete floor dedicated to a food court, 3 floors of professional office spaces, and 9 floors of 1-bed & 2-bed luxury apartments. Separate entrances for commercial, office, and residential areas ensure privacy and convenience for all.",
    features: [
      "3 Floors Car Parking",
      "Lower Ground + Ground + 2 Floors Commercial Shops",
      "Dedicated Food Court Floor",
      "4th-6th Floors: Professional Office Spaces",
      "7th-15th Floors: 1-Bed & 2-Bed Luxury Apartments",
      "Separate Entrances for Commercial, Office & Residential",
      "HVAC Central Heating & Cooling System",
      "14' Roof Height for Each Floor",
      "Modern Escalators",
      "Advanced Security System",
      "Elegant Flooring",
      "Pray Area",
      "Ladies Common Room",
      "Fire Fighting Equipment",
      "24/7 Power Backup",
      "Separate Lifts for Offices",
      "Wide & Established Corridors",
      "Carefully Crafted Living Spaces",
      "Privacy-Focused Design",
      "Prime Location in G-13/4",
      "Part of Red Sun's 50+ Completed Projects Legacy",
    ],
    gallery: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600",
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=600",
      "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600",
      "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=600",
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600",
    ],
  },
  // Islamabad Heights — B7 Marketing and Developers
  {
    id: 10,
    companyId: 5,
    title: "Islamabad Heights",
    route: "islamabad-heights",
    image: islamabad_heights_cover,
    location: "Sector B-17, Islamabad",
    city: "Islamabad",
    type: "Luxury Residential High-Rise",
    status: "Pre-Launching",
    duration: "25% Down Payment + 36 Monthly Installments + 10% on Possession",
    description:
      "Islamabad Heights is a prestigious residential high-rise development in the heart of Sector B-17, Islamabad, brought to you by B7 Marketing and Developers. This architectural marvel redefines urban living with its modern design, panoramic city views, and world-class amenities. The project offers a diverse range of living spaces including studio apartments, 1-bedroom, 2-bedroom, 3-bedroom units, and luxurious penthouses. With a 17-storey structure featuring 15 residential floors, Islamabad Heights promises an elevated lifestyle with breathtaking views of the Margalla Hills and the city skyline. Every detail has been meticulously crafted to provide residents with the perfect blend of comfort, convenience, and sophistication. From the 7-foot-wide corridors to the spacious balconies and modern kitchens, Islamabad Heights sets a new benchmark for luxury living in Islamabad.",
    features: [
      "17-Storey Residential High-Rise",
      "15 Residential Floors",
      "Studio Apartments (356-816 sq ft)",
      "1-Bed Apartments (484-601 sq ft)",
      "2-Bed Apartments (1010-1341 sq ft)",
      "3-Bed Apartments (1488 sq ft)",
      "Luxurious Penthouses (1020-2092 sq ft)",
      "7-Foot Wide Corridors",
      "Spacious Balconies with Margalla Hills Views",
      "Modern European-Style Kitchens",
      "Premium Bathroom Fittings",
      "Open Terrace Spaces",
      "Elegant Lobby Lounge",
      "High-Speed Elevators",
      "24/7 CCTV Security",
      "Earthquake Resistant Structure",
      "Smart Parking System",
      "G.Duct (9'-6\" x 7'-9\")",
      "Elevator Duct (8'-0\" x 9'-0\")",
      "Convenient Location in B-17",
      "Easy Access to Motorway M1/M2",
      "10 Mins Drive to New Islamabad Airport",
      "15 Mins Drive to CPEC Route",
      "Prime Investment Opportunity",
    ],
    gallery: [
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600",
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600",
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=600",
      "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600",
      "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=600",
    ],
  },
  {
    id: 1,
    companyId: 1,
    title: "Floria Heights",
    route: "floria-heights",
    image: floria_heights_cover,
    location: "Block A, Faisal Hills, Adjacent to Margalla Hills, Islamabad",
    city: "Islamabad",
    type: "Luxury Residential High-Rise",
    status: "Pre-Launching",
    duration: "Flexible Installment Plan",
    description:
      "Floria Heights is an elevated luxury residential project by Seven Ventures offering breathtaking Margalla Hills views, refined architecture, premium wellness amenities, and thoughtfully designed modern residences in Faisal Hills Islamabad.",
    features: [
      "Sky Gardens",
      "Swimming Pool",
      "Turkish Hamam",
      "Gymnasium",
      "Smart Home System",
      "EV Recharge Station",
      "Kids Play Area",
      "24/7 CCTV Security",
    ],
    gallery: [
      "https://images.unsplash.com/photo-1460317442991-0ec209397118?w=600",
      "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?w=600",
      "https://images.unsplash.com/photo-1494526585095-c41746248156?w=600",
    ],
  },
  {
    id: 2,
    companyId: 2,
    title: "Deen Villas",
    route: "deen-villas",
    image: deen_villas_cover,
    location: "Faisal Hills, Islamabad",
    city: "Islamabad",
    type: "Luxury Villas",
    status: "Booking Open",
    duration: "12 Months Installment Plan",
    description:
      "Deen Villas is a premium residential villa community developed by Deen Associates, offering elegant modern homes, secure surroundings, spacious layouts, and exceptional investment potential in the heart of Faisal Hills Islamabad.",
    features: [
      "25×50 Villas",
      "30×60 Villas",
      "Gated Community",
      "24/7 Security",
      "Modern Architecture",
      "Family Environment",
      "Premium Construction",
      "Flexible Installment Plan",
    ],
    gallery: [
      "https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=600",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600",
      "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=600",
    ],
  },
  {
    id: 3,
    companyId: 3,
    route: "royal-jewel",
    title: "Royal Jewel Tower",
    image: royal_jewel_cover,
    location:
      "Plot # 97, Executive Block, Main Double Road, Faisal Hills, Islamabad",
    city: "Islamabad",
    type: "Residential & Commercial High-Rise",
    status: "Pre-Launching",
    duration: "24 Months",
    description:
      "Royal Jewel is a state of the art residential and commercial project that is highly innovative and equipped with all modern facilities.",
    features: ["Swimming Pool", "Gym", "24/7 Security", "Underground Parking"],
    gallery: [
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600",
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600",
      "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=600",
    ],
  },
  {
    id: 4,
    companyId: 4,
    title: "Doha Heights",
    route: "doha-heights",
    image: doha_heights_cover,
    location:
      "Plot No 07, Main Boulevard, Block A, Faisal Hills, Adjacent to Sector B-17 Islamabad",
    city: "Islamabad",
    type: "Luxury Residential High-Rise",
    status: "Pre-Launching",
    duration: "5 Years Installment Plan",
    description:
      "Doha Heights is a premium luxury apartment project developed in Faisal Hills Islamabad offering breathtaking Margalla Hills views, elegant architecture, modern amenities, and flexible installment plans for luxurious urban living.",
    features: [
      "Margalla Hills View",
      "24/7 Security",
      "Underground Parking",
      "Smart Access Entry",
      "Theme Parks",
      "Glow Parks",
      "Jamia Masjid",
      "Sports Club",
    ],
    gallery: [
      "https://images.unsplash.com/photo-1460317442991-0ec209397118?w=600",
      "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?w=600",
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600",
    ],
  },
  {
    id: 5,
    companyId: 2,
    title: "Urban Complex",
    route: "urban-complex",
    image: urban_complex_cover,
    location:
      "Main Boulevard Corner, Block C, Faisal Hills, N-5 Taxila, Islamabad",
    city: "Islamabad",
    type: "Integrated Living, Working & Shopping Spaces",
    status: "Launching",
    duration: "Flexible Installment Plan",
    description:
      "Urban Complex is an outstanding project developed by Deen Associates and Kohsar Builders. It offers excellent access to the entire city, providing refreshing & comfortable living, enjoyable working environment, and energy-saving efficient office spaces. Comprising a 7-floor building with a total surface area of approximately 2 Kanal, the project is located on the Main Boulevard Corner of Block C, Faisal Hills. Driven by the philosophy of 'Sada Sukhi Raho', Urban Complex is designed to provide everything needed to work productively and live life to the full.",
    features: [
      "7 Floors Building",
      "Approx 2 Kanal Total Area",
      "19 Commercial Shops",
      "12 Corporate Offices",
      "1, 2 & 3 Bedroom Luxury Apartments",
      "Earthquake Resistant RCC Structure",
      "High-Speed Service Lifts",
      "International Fire Prevention System",
      "Generator Backup for Common Areas",
      "Ample Open Parking Space",
      "Branded Sanitary Fixtures",
      "Margalla Hills View",
      "2 Mins from M-1 Motorway",
      "2 Mins from G.T. Road",
      "5 Mins from Margalla Avenue",
      "10 Mins from Islamabad Airport",
      "5 Mins from CPEC Route",
      "25 Mins from Faisal Masjid",
    ],
    gallery: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600",
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=600",
      "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600",
    ],
  },
  {
    id: 6,
    companyId: 5,
    title: "B7 Tower 1",
    route: "b7-tower-1",
    image: b7_tower_cover,
    location:
      "Plot # 112, Jinnah Avenue, Sector F7/G7, Blue Area, Islamabad",
    city: "Islamabad",
    type: "Premium Commercial Office Tower",
    status: "Pre-Launching",
    duration: "25% Down Payment + 4 Quarterly Installments",
    description:
      "B7 Tower 1 is a premium commercial development situated on the prestigious Jinnah Avenue in the heart of Islamabad's Blue Area. Featuring 8 exclusive floors of modern, glass-facade office spaces, B7 Tower 1 is designed to elevate your business. From the lower ground to the 8th floor, each level offers spacious net areas, open terraces, and state-of-the-art amenities including high-speed elevators, kitchenettes, and dedicated wheelchair accessibility. 'From Vision to Value'—secure your prime commercial address today.",
    features: [
      "8 Premium Commercial Floors",
      "Glass Façade Modern Architecture",
      "High-Speed Elevators (6'-8\" x 7')",
      "Dedicated Wheelchair Lifter",
      "Open Terraces & Balconies",
      "Kitchenettes on Every Floor",
      "Secure Basement & Open Parking",
      "Premium Sanitary Fixtures",
      "Overhead Water Tank",
      "24/7 CCTV Security",
      "Top Roof Open Terrace (1,864 SFT)",
      "Total Gross Area: ~29,184 SFT",
      "Prominent Location: Jinnah Avenue, Blue Area",
      "Direct Access to Major Islamabad Routes",
      "Close to Islamabad Serena Hotel & Centaurus",
      "Ideal for Corporate HQs & IT Offices",
    ],
    gallery: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600",
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=600",
      "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600",
    ],
  },
  {
    id: 7,
    companyId: 6,
    title: "Valencia Heights",
    route: "valencia-heights",
    image: valencia_heights_cover,
    location: "Plot #9, Main Boulevard, FMC, B-17, Islamabad",
    city: "Islamabad",
    type: "Fully Family Residential Project",
    status: "Pre-Launching",
    duration: "Flexible Installment Plan",
    description:
      "Valencia Heights is a fully family residential project located on Plot #9, Main Boulevard, FMC, B-17, Islamabad. Offering stunning views of the Margalla Hills and Motorway M-1, this project features luxurious studios, 1-3 bedroom apartments, and magnificent duplex penthouses. With RDA approval and prime location just minutes from B-17 Gate 2 and FMC Gate, Valencia Heights promises an elevated lifestyle with premium amenities including swimming pool, gymnasium, mosque, daycare center, and double basement parking.",
    features: [
      "Studio Apartments (340 sqft)",
      "Single Bed Apartments (400-560 sqft)",
      "Double Bed Apartments (1073 sqft)",
      "Triple Bed Apartments (1120 sqft)",
      "Duplex Penthouses (2062-3562 sqft)",
      "Swimming Pool & Terrace in Penthouse",
      "State-of-the-Art Gymnasium",
      "Mosque on Premises",
      "Daycare Center",
      "Double Basement Car Parking",
      "Modern Elevators",
      "Reception & Corridor",
      "RDA Approved",
      "3 Minutes Drive to B-17 Gate 2",
      "1 Minute Drive to FMC Gate",
      "38 Minutes Drive to Airport",
      "40 Minutes Drive to Saddar",
      "20 Minutes Drive to 26 Number Chungi",
      "Motorway (M-1) View Side",
    ],
    gallery: [
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600",
      "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=600",
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600",
      "https://images.unsplash.com/photo-1582139329536-e7284fece509?w=600",
      "https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=600",
    ],
  },
];